import PropTypes from "prop-types";
import { DeleteOutline, ModeEdit } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { displayDocuments } from "../../utils/helpers";
import { EmptyWrapper } from "./Elements";
import styled from "styled-components";

type TDetailsCardProps = {
  viewData: Record<string, any>;
  onDelete?: () => void;
  onEdit?: () => void;
  short?: boolean;
  horizontal?: boolean;
};

const DetailsCard = (props: TDetailsCardProps) => {
  const {
    viewData,
    onDelete,
    onEdit,
    short = false,
    horizontal = false,
  } = props;
  const [attachments, setAttachments] = useState<Record<string, any>>({});
  const [inputAttachments, setInputAttachments] = useState<Record<string, any>>(
    {},
  );

  useEffect(() => {
    const getInputAttachments = () => {
      if (!viewData || Object.keys(viewData).length === 0) return;

      const attachmentKeys = Object.keys(viewData).filter((key) =>
        key.startsWith("attachments"),
      );
      const newViewData = { ...viewData };

      let newAttachments = attachmentKeys.reduce((acc, key) => {
        acc[key] = newViewData[key];
        delete viewData[key];
        return acc;
      }, {});

      if (Object.keys(newAttachments).length <= 0) {
        return;
      }

      newAttachments = Object.keys(newAttachments).reduce((acc, key) => {
        if (key.endsWith("caption")) {
          const fileKey = attachmentKeys.find((k) => k.endsWith("file"));
          if (!fileKey) return acc;
          if (
            newAttachments[fileKey] &&
            typeof newAttachments[fileKey] === "object"
          ) {
            acc[newAttachments[key]] = newAttachments[fileKey].name;
          }
        }
        return acc;
      }, {});

      setInputAttachments(newAttachments);
    };
    const getBackendAttachments = () => {
      if (!viewData || Object.keys(viewData).length === 0) return;
      let newAttachments = Object.keys(viewData)
        .filter((key) => key.endsWith("_attachments"))
        .reduce((acc, key) => {
          acc[key] = viewData[key];
          return acc;
        }, {});

      if (Object.keys(newAttachments).length <= 0) {
        return;
      }
      newAttachments = Object.keys(newAttachments).map((key) =>
        displayDocuments(newAttachments[key]),
      );
      setAttachments(newAttachments[0]);
    };
    getBackendAttachments();
    getInputAttachments();
  }, [viewData]);

  return (
    <div className={`card ${short && "col-lg-6"}`} style={{ marginBottom: 10 }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
        }}
      >
        {onEdit ? (
          <button
            style={{
              padding: 5,
              paddingBottom: 0,
              background: "none",
              border: "none",
              display: "inline-block",
            }}
            aria-label="Edit"
            type="button"
            onClick={onEdit}
          >
            <ModeEdit />
          </button>
        ) : null}
        {onDelete ? (
          <button
            style={{
              padding: 5,
              paddingBottom: 0,
              background: "none",
              border: "none",
              display: "inline-block",
            }}
            aria-label="Delete"
            type="button"
            onClick={onDelete}
          >
            <DeleteOutline />
          </button>
        ) : null}
      </div>
      <div className="card-body">
        <table
          className={`table table-bordered detail-view ${horizontal && "table-striped"}`}
        >
          <tbody style={{ fontSize: "0.8rem" }}>
            {Object.keys(viewData).map((key) => {
              if (typeof viewData[key] !== "object" && key !== "index") {
                return (
                  <tr key={key}>
                    <TableHeaderWrapper>
                      {String(key).replaceAll("_", " ")}
                    </TableHeaderWrapper>
                    <td>{viewData[key]}</td>
                  </tr>
                );
              }
              return null;
            })}
            {Object.keys(inputAttachments).length > 0 &&
              Object.keys(inputAttachments).map((key) => {
                return (
                  <tr key={key}>
                    <TableHeaderWrapper>{key}</TableHeaderWrapper>
                    <td>{inputAttachments[key]}</td>
                  </tr>
                );
              })}

            {Object.keys(attachments).length > 0 &&
              Object.keys(attachments).map((key) => {
                return (
                  <tr key={key}>
                    <TableHeaderWrapper>
                      {String(key).replaceAll("_", " ")}
                    </TableHeaderWrapper>
                    <td>
                      {attachments[key] || <EmptyWrapper>Empty</EmptyWrapper>}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const TableHeaderWrapper = styled.th`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-transform: capitalize;
  @media (max-width: 960px) {
    max-width: 100px;
  }
`;

DetailsCard.propTypes = {
  viewData: PropTypes.shape({}),
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
};

export default DetailsCard;
